import React from 'react';
import { SideNavBody } from '@atlaskit/navigation-system/layout/side-nav';
import { SkeletonNavMenuItems } from '@jira/navigation-apps__sidebar-nav4-sidebars-common-core/src/common/ui/skeleton-nav-menu-items/main.tsx';

export const SpaceAgentsSidebarSkeleton = (): React.JSX.Element => (
	<SideNavBody>
		<SkeletonNavMenuItems />
	</SideNavBody>
);

export default SpaceAgentsSidebarSkeleton;
